


















import BaseComponent from '@/core/base.component';
import { Component, Prop } from 'vue-property-decorator';
@Component({
  name: 'ConfirmDialog',
})
export default class ConfirmDialog extends BaseComponent {
  @Prop({ required: true }) readonly dialog: boolean;
  @Prop() readonly title: string;
  toggle() {
    this.$emit('update:dialog', !this.dialog);
  }
  confirm() {
    this.toggle();
    this.$emit('confirm');
  }
}
